<script setup lang="ts">
    import { Toaster } from '@/components/shadcn/ui/sonner';

    import CenteredFrame from '@/components/tellscale/layouts/CenteredFrame.vue';
    import DashboardFrame from "@/components/tellscale/layouts/DashboardFrame.vue";

    import { useRecommendationPortal } from '@/stores/portal';

    const route = useRoute();

    const portal = useRecommendationPortal();

    useFavicon(computed(() => portal.value?.favicon || '/tellscale-favicon.png'));

    /**
     * DYNAMIC LAYOUT SYSTEM
     *
     * Layout is determined by route meta configuration in page files:
     *
     * <route lang="yaml">
     *   meta:
     *     layout: dashboard
     * </route>
     *
     * Defaults to CenteredFrame if no layout is specified
     */
    const layouts = {
        centered: CenteredFrame,
        dashboard: DashboardFrame,
    };

    const layout = computed(() => {
        const layout = (route.meta.layout as keyof typeof layouts);
        return layout ? layouts[layout] : CenteredFrame;
    });
</script>

<template>
    <Toaster rich-colors/>

    <component :is="layout">
        <RouterView/>
    </component>
</template>